import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { IMediaItemSizeMenuItem, FiTextItemMediaPanelSizeMenuItems } from './fi-text-item-media-panel-size-menu-items';
import { FiTextItemMediaPanelItemBaseComponent } from '@fi-app/utilities/insert-media/fi-text-item-media-panel-handler/fi-text-item-media-panel-item-base/fi-text-item-media-panel-item-base.component';

@Component({
    selector: 'fi-text-item-media-panel-size',
    template: `
        <button
            mat-icon-button
            class="fi-text-item-media-panel-action"
            [matMenuTriggerFor]="menu"
            (menuOpened)="toggleMenuBrandedClass(true)"
            (menuClosed)="toggleMenuBrandedClass(false)"
        >
            <mat-icon><span [ngClass]="{ BrandedColor: isMenuOpened }" class="fa fa-expand"></span></mat-icon>
        </button>

        <mat-menu #menu="matMenu">
            @for (menuItem of mediaItemSizeMenuItems; track menuItem) {
                <button
                    mat-menu-item
                    class="fi-text-item-media-panel-menu-item fi-text-item-media-size-menu"
                    (click)="menuItemClick(menuItem.mediaItemClass, $event)"
                >
                    <span class="menu-item-label">{{ menuItem.label | fiAppText }}</span>
                    <mat-icon>
                        @if (isSizeSelected(menuItem.mediaItemClass)) {
                            <span class="fas fa-check BrandedColor"></span>
                        }
                    </mat-icon>
                </button>
            }
        </mat-menu>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-text-item-media-panel-size' },
    standalone: false,
})
export class FiTextItemMediaPanelSizeComponent extends FiTextItemMediaPanelItemBaseComponent {
    @Input() currentItemMediaSizeClass: string;
    @Output() setSizeClass = new EventEmitter<string>();
    mediaItemSizeMenuItems: IMediaItemSizeMenuItem[] = FiTextItemMediaPanelSizeMenuItems;

    menuItemClick(mediaItemClass: string, $event): void {
        $event.stopPropagation();
        this.setSizeClass.emit(mediaItemClass);
        this.toggleMenu();
    }

    isSizeSelected(sizeClass: string): boolean {
        return sizeClass === this.currentItemMediaSizeClass;
    }
}
